export default __webpack_public_path__ + "static/home_intro-720-14e1f93ad50225e5f26df9248370b31b.ogv";